




























import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { UserInfo } from "@/controller/user";
import UserTableUserRolePicker from "./UserTableUserRolePicker.vue";
import TableDeleteButton from "@/components/TableDeleteButton.vue";

@Component({
  components: {
    UserTableUserRolePicker,
    TableDeleteButton
  }
})
export default class UserTable extends Vue {
  @Prop({ type: Array, required: true })
  users!: UserInfo[];

  @Emit("click")
  emitClick(email: string) {
    return email;
  }

  onClickDelete(event: Event, email: string) {
    this.emitClick(email);
  }

  onClickEdit(role: string, email: string) {
    this.$emit("edit", email, role);
  }
}
